// extracted by mini-css-extract-plugin
module.exports = {"popover":"BooleanInputPopover_popover__1G0Ct","buttons":"BooleanInputPopover_buttons__1ICYR","danger":"BooleanInputPopover_danger__2ldfd"};